import { render, staticRenderFns } from "./BillingRemittanceList.vue?vue&type=template&id=321e474b"
import script from "./BillingRemittanceList.vue?vue&type=script&lang=ts"
export * from "./BillingRemittanceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports